<template>
	<component v-if="tag" :is="tag" :class="contentClass">
		<template v-for="(part, index) in parts" :key="`${index}-${part.value}`">
			<LegalLink
				v-if="part.type === 'legal'"
				:name="part.value"
				:wrapper="wrapper"
			/>
			<template v-else>{{ part.value }}</template>
		</template>
	</component>
	<template v-else>
		<template v-for="(part, index) in parts" :key="`${index}-${part.value}`">
			<LegalLink
				v-if="part.type === 'legal'"
				:name="part.value"
				:wrapper="wrapper"
			/>
			<template v-else>{{ part.value }}</template>
		</template>
	</template>
</template>

<script setup>
import { computed } from 'vue';
import LegalLink from './LegalLink.vue';

const LEGAL_TOKEN_REGEXP = /@legal\(([^)]+)\)/g;

const props = defineProps({
	text: { type: String, default: '' },
	tag: { type: String, default: '' },
	contentClass: { type: [String, Array, Object], default: '' },
	wrapper: { type: Boolean, default: true }
});

const parts = computed(() => {
	const items = [];
	let lastIndex = 0;

	for (const match of props.text.matchAll(LEGAL_TOKEN_REGEXP)) {
		const [token, legalName] = match;
		const startIndex = match.index || 0;

		if (startIndex > lastIndex) {
			items.push({
				type: 'text',
				value: props.text.slice(lastIndex, startIndex)
			});
		}

		items.push({
			type: 'legal',
			value: legalName.trim()
		});

		lastIndex = startIndex + token.length;
	}

	if (lastIndex < props.text.length) {
		items.push({
			type: 'text',
			value: props.text.slice(lastIndex)
		});
	}

	if (!items.length) {
		items.push({
			type: 'text',
			value: props.text
		});
	}

	return items;
});
</script>